import React, { PropsWithChildren } from 'react';
import { CSSTransition } from 'react-transition-group';
import css from './index.module.scss';

export interface FadeProps {
  onTransitionEnd?: () => void;
  in: boolean;
  timeout?: number;
  nodeRef: React.RefObject<HTMLElement>;
}

export const Fade: React.FunctionComponent<PropsWithChildren<FadeProps>> = ({
  children,
  onTransitionEnd,
  in: inProp,
  nodeRef,
  timeout = 500,
}) => (
  <CSSTransition
    data-component="Fade"
    classNames={{
      appear: css.enter,
      appearActive: css.enterActive,
      enter: css.enter,
      enterActive: css.enterActive,
      exit: css.exit,
      exitActive: css.exitActive,
    }}
    mountOnEnter
    unmountOnExit
    appear
    in={inProp}
    timeout={timeout}
    onExited={onTransitionEnd}
    nodeRef={nodeRef}
  >
    {children}
  </CSSTransition>
);
